import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot,CanActivate, Router } from '@angular/router';
import { AuthService } from 'app/shared/services/auth.service';
import { HttpErrorResponse } from '@angular/common/http';
import { UserService } from 'app/shared/services/user.service';



@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  permissionList:any

  showDB = false;

  showCOM = false;
  showEM = false;
  showEM_LIST = false;
  showSM = false;
  showSM_LIST = false;
  showCM = false;
  showCM_LIST = false;
  showVH= false;
  showVH_LIST= false;
  
  showIM = false;
  showIM_LIST = false;



  showQT = false;
  showQT_LIST = false;
  showINV = false;
  showINV_LIST = false;
  showRECEIPT = false;
  showRECEIPT_LIST = false;

  showEXP = false;
  showEXP_LIST = false;

  showMACC = false;
  showCB_ENTRY = false;
  showCHQ = false; 
  showCB_BAL = false;
 

  showRPT_CB= false;
  showRPT_SALE= false;
  showRPT_INV= false;
  showRPT_EXP= false;
  showRPT_PNL= false;


  showUSER= false;
  showSETTINGS= false;
  showBACKUP= false;
  showFILE= false;
 


  constructor(private authService : AuthService, 
    private router : Router,
    private userService: UserService,
    ){

    }

                      
 async canActivate(route:ActivatedRouteSnapshot) :Promise<boolean>{

    await this.getUserPermissionByUserName();
    await this.assignRoles(this.authService.controlPermissionArray);

    if(this.authService.loggedIn() && this.authService.controlPermissionArray.length){
     
      switch(route.data?.module) { 
        case 'DB':         
            if(!this.showDB){
              this.router.parseUrl('/login');
              return false;
            }
          break;
        case 'COM':
            if(!this.showCOM){
              this.router.parseUrl('/login');
              return false;
            }
          break;
        case 'EM':
          if(!this.showEM){
            this.router.navigate(['/login']);
            return false;
          }
          break;
        case 'EM_LIST':
          if(!this.showEM_LIST){
            this.router.navigate(['/login']);
            return false;
          }
          break;
        case 'SM':
          if(!this.showSM){
            this.router.navigate(['/login']);
            return false;
          }
          break;
        case 'SM_LIST':
          if(!this.showSM_LIST){
            this.router.navigate(['/login']);
            return false;
          }
          break;
        case 'CM':
          if(!this.showCM){
            this.router.navigate(['/login']);
            return false;
          } 
          break;
        case 'CM_LIST':
          if(!this.showCM_LIST){
            this.router.navigate(['/login']);
            return false;
          }
          break;
        case 'VH':
            if(!this.showCM_LIST){
              this.router.navigate(['/login']);
              return false;
            }
          break;
        case 'VH_LIST':
            if(!this.showCM_LIST){
              this.router.navigate(['/login']);
              return false;
            }
          break;
        case 'IM':
          if(!this.showIM){
            this.router.navigate(['/login']);
            return false;
          }
          break;
        case 'IM_LIST':
          if(!this.showIM_LIST){
            this.router.navigate(['/login']);
            return false;
          }
          break;
        case 'QT':
          if(!this.showQT){
            this.router.navigate(['/login']);
            return false;
          }
          break;
        case 'QT_LIST':
          if(!this.showQT_LIST){
            this.router.navigate(['/login']);
            return false;
          }
          break;
        case 'INV':
          if(!this.showINV){
            this.router.navigate(['/login']);
            return false;
          }
          break;
        case 'INV_LIST':
          if(!this.showINV_LIST){
            this.router.navigate(['/login']);
            return false;
          }
          break;
        case 'RECEIPT':
          if(!this.showRECEIPT){
            this.router.navigate(['/login']);
            return false;
          }
          break;
        case 'RECEIPT_LIST':
          if(!this.showRECEIPT_LIST){
            this.router.navigate(['/login']);
            return false;
          }
          break;
        case 'EXP':
          if(!this.showEXP){
            this.router.navigate(['/login']);
            return false;
          }
          break;
        case 'EXP_LIST':
          if(!this.showEXP_LIST){
            this.router.navigate(['/login']);
            return false;
          }
          break;
        case 'MACC':
          if(!this.showMACC){
            this.router.navigate(['/login']);
            return false;
          }
          break;
        case 'CB_ENTRY':
          if(!this.showCB_ENTRY){
            this.router.navigate(['/login']);
            return false;
          }
          break;
        case 'CHQ':
            if(!this.showCHQ){
              this.router.navigate(['/login']);
              return false;
            }
          break;
        case 'CB_BAL':
            if(!this.showCB_BAL){
              this.router.navigate(['/login']);
              return false;
            }
          break;
        case 'RPT_CB':
          if(!this.showRPT_CB){
            this.router.navigate(['/login']);
            return false;
          }
          break;
        case 'RPT_SALE':
          if(!this.showRPT_SALE){
            this.router.navigate(['/login']);
            return false;
          }
          break;
        case 'RPT_INV':
            if(!this.showRPT_INV){
              this.router.navigate(['/login']);
              return false;
            }
          break;
        case 'RPT_EXP':
          if(!this.showRPT_EXP){
            this.router.navigate(['/login']);
            return false;
          }
          break;
        case 'RPT_PNL':
          if(!this.showRPT_PNL){
            this.router.navigate(['/login']);
            return false;
          }
          break;
        case 'USER':
          if(!this.showUSER){
            this.router.parseUrl('/login');
            return false;
          }
          break;
        case 'SETTINGS':
          if(!this.showSETTINGS){
            this.router.navigate(['/login']);
            return false;
          }
          break;
        case 'BACKUP':
          if(!this.showBACKUP){
            this.router.navigate(['/login']);
            return false;
          }
          break;
        default:
      }

      return true


    }else{
      this.router.navigate(['/login']);
      return false;
    }


  }


   async getUserPermissionByUserName(){   
      const  permissionList =  await this.userService.getUserPermissionPromise(this.authService.getUserLoggedIn())
      this.authService.controlPermissionArray = permissionList;
   
  }

  async assignRoles(roles: any []) {
 
   if(roles.length){
    this.showDB = !!roles[0].module;
    this.showCOM = !!roles[1].create;
    this.showEM = !!roles[2].create;
    this.showEM_LIST = !!roles[2].read;
    this.showSM = !!roles[3].create;
    this.showSM_LIST = !!roles[3].read;
    this.showCM = !!roles[4].create;
    this.showCM_LIST = !!roles[4].read;
    this.showVH = !!roles[5].create;
    this.showVH_LIST = !!roles[5].read;
    this.showIM = !!roles[6].create;
    this.showIM_LIST = !!roles[6].read;
    this.showQT = !!roles[7].create;
    this.showQT_LIST = !!roles[7].read;
    this.showINV = !!roles[8].create;
    this.showINV_LIST = !!roles[8].read;
    this.showRECEIPT = !!roles[9].create;
    this.showRECEIPT_LIST = !!roles[9].read;
    this.showEXP = !!roles[10].create;
    this.showEXP_LIST = !!roles[10].read;
    this.showMACC = !!roles[11].read;
    this.showCB_ENTRY = !!roles[12].read;
    this.showCHQ = !!roles[13].module;
    this.showCB_BAL = !!roles[14].module;
    this.showRPT_CB = !!roles[15].module;
    this.showRPT_SALE = !!roles[16].module;
    this.showRPT_INV = !!roles[17].module;
    this.showRPT_EXP = !!roles[18].module;
    this.showRPT_PNL = !!roles[19].module;
    this.showUSER = !!roles[20].module;
    this.showSETTINGS = !!roles[21].module;
    this.showBACKUP = !!roles[22].read;
    this.showFILE = !!roles[23].read;

   }

  }



}
